import { PriorityQueue, ON_REMOVE_FROM_FUTURE } from '@segment/analytics-core';
export { PriorityQueue, ON_REMOVE_FROM_FUTURE };
//# sourceMappingURL=index.js.map